<template>
<div>
    <div class="block_box">
        <div class="block " @click="showModal">
            <div class="quiz_image">
                <img width="400" height="400" src="~/assets/diamond_quiz/quiz.jpg" alt="Quiz-Diamond">
            </div>
            <div class="info">
                <p class="mb-0">Not sure which diamond to choose?<br>Let us help you!</p>
            </div>
        </div>
    </div>
    <div class="modal fade " id="modal-tall" ref="modal" data-bs-backdrop="true" tabindex="-1"
        aria-labelledby="modal-tall" data-bs-tar aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-body p-0">
                    <div class="model_block">
                        <div class="main">
                            <div v-if="currentPage === 1">
                                <DiamondQuizDiamondIntro  @close="hideModal" />
                            </div>

                            <div v-if="currentPage === 2">
                                <DiamondQuizDiamondBudget @close="hideModal" />
                            </div>

                            <div v-if="currentPage === 3">
                                <DiamondQuizDiamondShapeBox  @close="hideModal"/>
                            </div>

                            <div v-if="currentPage === 4">
                                <DiamondQuizDiamondPriority  @close="hideModal"/>
                            </div>

                            <div v-if="currentPage === 5">
                                <DiamondQuizDiamondResult  @close="hideModal"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
            
</div>

</template>


<script setup>
import { diamondQuizStore } from '@/stores/diamond_quiz/diamond_quiz';

const store = diamondQuizStore()

const modal = ref(null)
const currentPage = computed(()=>store.currentPage);

const showModal = () => {
    // openModal.value = true;
    nextTick(() => {
        const modalElement = modal.value;
        if (modalElement) {
            const modalInstance = new bootstrap.Modal(modalElement);
            modalInstance.show();
        }
    });
};

const hideModal = () => {
    const modalElement = modal.value;
    if (modalElement) {
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide();
        }
    }
   
};



</script>


<style scoped>
.block_box {
    /* max-width: 610px; */
    max-width: 40%;
    margin: 0 auto;
    /* margin-bottom: 30px; */
}



.block {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px solid #eaeaea;
    border-radius: 8px;
    background: linear-gradient(to right, #ffffff 22%, #f5f5f5 100%);
    /* padding: 21px 101px; */
    /* gap: 20px; */
    width: 100%;
    margin: 0 auto;
}

.quiz_image {
    width: 14%;
}

.info p {
    font-size: 18px;
    color: #353535;
    margin-left: 20px;
    width: 100%;
    font-weight: 500;
}


.main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90vh;
    overflow: auto;
    overflow-x: hidden;
}

.modal-content {
    background-image: url('~/assets/diamond_quiz/quizbg.jpg');
    background-size: cover;
    background-position: center center;
    /* position: relative; */
}

.model_block {
    padding: 1%;
}

.largesvg {
    transform: scale(1.3);
}

.title_block {
    display: flex;
    align-items: flex-start;
    justify-content: center;
}

h3 {
    font-size: 32px;
    font-weight: 400;
    color: #212529;
}

.title_block p {
    font-size: 16px;
    color: #353535;
    letter-spacing: 4px;
    text-transform: uppercase;
}

.close {
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
}

.pagination-dots {
  display: flex;
  justify-content: center;
  /* margin-top: 5%; */
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.dot {
  height: 10px;
  width: 10px;
  margin: 0 5px;
  background-color: #c4c4c4;
  border-radius: 50%;
  cursor: pointer;
  
}

.active-dot {
  background-color: var(--green);
}

@media(max-width:1024px) {
    .block {
        padding: 5px 10px;
    }
}


@media(max-width: 992px) {
    .info p {
        font-size: 16px;
    }
    .block_box {
        max-width: 50%;
    }

    .quiz_image {
        width: 18%;
    }

    .block {
        padding: 0;
    }

}


@media(max-width: 768px) {
    h3 {
        font-size: 24px;
    }

    .title_block p {
        font-size: 14px;
        letter-spacing: 1.5px;
        color: #606060;
        margin-bottom: 0;
    }

    .title_block {
        margin-bottom: 0;
    }

    .model_block {
        padding: 2%;
    }
    .main {
        height: auto;
        min-height: 50vh;
    }

    .info p {
        font-size: 14px;
    }
    .block_box {
        max-width: 70%;
    }

    .quiz_image {
        width: 17%;
    }

    
}

@media(max-width:500px) {
    .block_box {
        max-width: 90%;
    }
}

</style>